import { useMutation } from "@tanstack/react-query"
import { useNavigate } from "react-router"
import { toast } from "sonner"

import { queryClient } from "@/App.tsx"
import type { DataPoint, DataPointType } from "@/types/dataPointTypes.ts"

import { addDataPoint } from "../api/addDataPoint.ts"
import { updateDataPoint } from "../api/updateDataPoint.ts"

import TagDataPointForm from "./forms/TagDataPointForm.tsx"

import type { DataPointRequest } from "../types/dataPointDTOs.ts"

export default function DataPointEditor({
  dataPoint,
  type,
}: {
  dataPoint?: DataPoint
  type: DataPointType
}) {
  const navigate = useNavigate()

  const addMutation = useMutation({
    mutationFn: (variables: DataPointRequest) => addDataPoint(variables),
    onSuccess: () => {
      toast("Data Point added", { richColors: true })
      queryClient.invalidateQueries({ queryKey: ["allDataPoints"] })
      navigate("/datapoints/defs")
    },
  })

  const updateMutation = useMutation({
    mutationFn: (variables: DataPointRequest) => updateDataPoint(dataPoint?.id || 0, variables),
    onSuccess: () => {
      toast("Data Point updated")
      queryClient.invalidateQueries({ queryKey: ["allDataPoints"] })
      queryClient.invalidateQueries({
        queryKey: ["dataPoint", { id: dataPoint?.id }],
      })
      navigate("/datapoints/defs")
    },
  })

  let form = (
    <TagDataPointForm
      onSubmit={(req) => addMutation.mutate(req)}
      mutating={addMutation.isPending}
    />
  )
  if (dataPoint != undefined) {
    if (dataPoint.$type == "tag") {
      form = (
        <TagDataPointForm
          dataPoint={dataPoint}
          onSubmit={(req) => updateMutation.mutate(req)}
          mutating={updateMutation.isPending}
        />
      )
    }
  } else {
    if (type == "tag") {
      form = (
        <TagDataPointForm
          onSubmit={(req) => addMutation.mutate(req)}
          mutating={addMutation.isPending}
        />
      )
    }
  }

  return form
}
